import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            setIsVisible(true);
        } else if (consent === 'accepted') {
            loadAnalytics();
        }
    }, []);

    const loadAnalytics = () => {
        if (window.gtag) return; // Already loaded

        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-1LT9VBM6GC';
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-1LT9VBM6GC');
        `;
        document.head.appendChild(script2);
    };

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setIsVisible(false);
        loadAnalytics();
    };

    const handleReject = () => {
        localStorage.setItem('cookie_consent', 'rejected');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#fff',
            boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)',
            padding: '24px',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '24px',
            flexWrap: 'wrap',
            borderTop: '1px solid #e5e7eb',
            fontFamily: 'Mulish, sans-serif'
        }}>
            <div style={{ maxWidth: '800px', flex: 1 }}>
                <p style={{ margin: '0 0 8px 0', color: '#111827', fontSize: '16px', fontWeight: '600' }}>
                    Cookie Preferences
                </p>
                <p style={{ margin: 0, color: '#4b5563', fontSize: '14px', lineHeight: '1.5' }}>
                    We use cookies to enhance your experience and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
                    Read our <a href="/cookie-policy" style={{ color: '#3457D5', textDecoration: 'underline' }}>Cookie Policy</a>.
                </p>
            </div>
            <div style={{ display: 'flex', gap: '12px', whiteSpace: 'nowrap' }}>
                <button
                    onClick={handleReject}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db',
                        backgroundColor: '#fff',
                        color: '#374151',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f9fafb'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                >
                    Reject Non-Essential
                </button>
                <button
                    onClick={handleAccept}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#3457D5',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        boxShadow: '0 2px 4px rgba(52, 87, 213, 0.2)',
                        transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#2a46aa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3457D5'}
                >
                    Accept All
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
